import React, { useEffect, useRef, useCallback } from "react";
import { observer } from "mobx-react";
import Loader from "../util/Loader";
import Product from "./Product";
import ProductAd from "./ProductAd";

const Products = observer(({ products, crossSellProducts, ad, loadMoreProducts, hasMoreProducts = false, categoryId = 1, isLoading }) => {
  const observerTargetRef = useRef(null);
  const observerInstanceRef = useRef(null);

  const handleIntersection = useCallback((entries) => {
    const firstEntry = entries[0];
    if (firstEntry.isIntersecting && !isLoading && hasMoreProducts && loadMoreProducts) {
      loadMoreProducts();
    }
  }, [isLoading, hasMoreProducts, loadMoreProducts]);

  useEffect(() => {
    const target = observerTargetRef.current;
    if (!target) return;

    if (observerInstanceRef.current) {
      observerInstanceRef.current.disconnect();
    }

    const observer = new IntersectionObserver(handleIntersection, { threshold: [0, 1], rootMargin: "300px" });
    observer.observe(target);
    observerInstanceRef.current = observer;

    return () => {
      if (observerInstanceRef.current) {
        observerInstanceRef.current.disconnect();
        observerInstanceRef.current = null;
      }
    };
  }, [handleIntersection]);

  if (!products) return null;

  return (
    <div className="w-full pt-3 md:pt-6 pb-0 md:pb-16">
      <div className="md:grid md:grid-cols-[repeat(auto-fill,minmax(190px,1fr))] lg:grid-cols-[repeat(auto-fill,minmax(210px,1fr))] lg:gap-7 md:gap-3">
        {products.map((product, index) => (
          <React.Fragment key={product?.id + '-' + categoryId}>
            <Product product={product} crossSellProducts={crossSellProducts} />
            {index === 3 && ad && <ProductAd ad={ad} />}
          </React.Fragment>
        ))}
      </div>
      <div ref={observerTargetRef} style={{ height: '10px', marginTop: '-1px' }} />
      {(isLoading && hasMoreProducts) && <div className="text-center relative mt-10"><Loader /></div>}
    </div>
  );
});

export default Products;